import { Component } from '@angular/core';

import { BaseIconComponent } from '../base-icon.component';

@Component({
  selector: 'app-health-insurance-icon',
  template: `
    <svg
      [attr.width]="width"
      [attr.height]="height"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_459_1968)">
        <path
          d="M17.25 14.247C19.0266 14.9877 20.5443 16.2375 21.612 17.839C22.6797 19.4406 23.2496 21.3222 23.25 23.247"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.75001 23.25C3.74834 21.9353 4.01334 20.6339 4.52899 19.4246C5.04463 18.2152 5.8002 17.123 6.75001 16.214"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M17.25 12.75V15C17.25 15.9946 16.8549 16.9484 16.1516 17.6516C15.4484 18.3549 14.4946 18.75 13.5 18.75C12.5054 18.75 11.5516 18.3549 10.8483 17.6516C10.1451 16.9484 9.75 15.9946 9.75 15V12.75"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M2.25 11.25C3.07843 11.25 3.75 10.5784 3.75 9.75C3.75 8.92157 3.07843 8.25 2.25 8.25C1.42157 8.25 0.75 8.92157 0.75 9.75C0.75 10.5784 1.42157 11.25 2.25 11.25Z"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M3.75 9.75C4.54565 9.75 5.30871 10.0661 5.87132 10.6287C6.43393 11.1913 6.75 11.9544 6.75 12.75V21C6.75 21.5967 6.98705 22.169 7.40901 22.591C7.83097 23.0129 8.40326 23.25 9 23.25H11.25C11.8467 23.25 12.419 23.0129 12.841 22.591C13.2629 22.169 13.5 21.5967 13.5 21V18.75"
          [attr.stroke]="color"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M13.5 11.25C16.3995 11.25 18.75 8.8995 18.75 6C18.75 3.10051 16.3995 0.75 13.5 0.75C10.6005 0.75 8.25 3.10051 8.25 6C8.25 8.8995 10.6005 11.25 13.5 11.25Z"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M8.97607 3.33502C9.78894 4.17825 10.7635 4.84887 11.8415 5.30677C12.9196 5.76468 14.0788 6.00046 15.2501 6.00002C16.4364 6.00036 17.6103 5.75877 18.7001 5.29002"
          stroke="#00D5D3"
          stroke-width="1.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_459_1968">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  `,
})
export class HealthInsuranceIconComponent extends BaseIconComponent {}
